import React, { Dispatch, DispatchWithoutAction, FC } from 'react';
import { useSelector } from 'react-redux';

import { useI18n } from 'i18n';
import { IDownsampledMessageHistoryProcessor } from 'types/detectors';
import { downsampledMessageHistorySelector } from 'core/redux/selectors/processors';
import Intent from 'core/misc/ObjectActionIntent';
import ObjectActionDialogPopup from 'core/react/general/ObjectActionDialogPopup';
import RemoveDialog from 'core/react/general/RemoveDialog';

interface IRemoveDetectorDialogueProps {
  intent: Intent | null;
  isDisabled: boolean;
  onRemove: Dispatch<IDownsampledMessageHistoryProcessor>;
  onPopupClose: DispatchWithoutAction;
}

export const RemoveProcessorDialogue: FC<IRemoveDetectorDialogueProps> = (props) => {
  const { intent, isDisabled, onRemove, onPopupClose } = props;

  const { f } = useI18n();

  const { error } = useSelector(downsampledMessageHistorySelector);

  return intent && intent.action() === Intent.Action.Remove ? (
    <ObjectActionDialogPopup
      offset={intent.data().offset}
      onClose={onPopupClose}
      title={f('downsampled message history processor')}
      disabled={isDisabled}
      error={error}
    >
      <RemoveDialog
        object={intent.object()}
        title={f('downsampled message history processor')}
        text={f('are you sure you want to delete downsampled message history processor', {
          name: intent.object().name,
        })}
        onSubmit={onRemove}
        onCancel={onPopupClose}
      />
    </ObjectActionDialogPopup>
  ) : null;
};
